export default __webpack_public_path__ + "locales/en/Ldap.json?hash=621abaacdcaa55e0081acfd57386c39f";